import { render, staticRenderFns } from "./BoxSubCategorias.vue?vue&type=template&id=565a0da0&scoped=true"
import script from "./BoxSubCategorias.vue?vue&type=script&lang=js"
export * from "./BoxSubCategorias.vue?vue&type=script&lang=js"
import style0 from "./BoxSubCategorias.vue?vue&type=style&index=0&id=565a0da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a0da0",
  null
  
)

export default component.exports